import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SeoHead } from "../components/SeoHead";
import "./NotFoundPage.css";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
    <SeoHead title="404 — страница не найдена" noindex />
    <main className="nf">
      <div className="nf-glow" />
      <div className="nf-inner">
        <span className="eyebrow">{t("notFound.eyebrow")}</span>
        <div className="nf-code">
          4<span className="nf-code-serif">0</span>4
        </div>
        <h1 className="nf-title">
          {t("notFound.title")} <em>{t("notFound.titleItalic")}</em>
        </h1>
        <p className="nf-lead">{t("notFound.lead")}</p>
        <div className="nf-actions">
          <button className="btn-primary nf-btn-lg" onClick={() => navigate("/")}>
            {t("notFound.btnHome")}
          </button>
          <button className="btn-secondary nf-btn-lg" onClick={() => navigate("/catalog")}>
            {t("notFound.btnCatalog")}
          </button>
        </div>
        <div className="nf-links">
          <button className="nf-link" onClick={() => navigate("/catalog")}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7" rx="1.5"/>
              <rect x="14" y="3" width="7" height="7" rx="1.5"/>
              <rect x="3" y="14" width="7" height="7" rx="1.5"/>
              <rect x="14" y="14" width="7" height="7" rx="1.5"/>
            </svg>
            {t("notFound.linkCatalog")}
          </button>
          <button className="nf-link" onClick={() => navigate("/privacy")}>
            {t("notFound.linkPrivacy")}
          </button>
        </div>
      </div>
    </main>
    </>
  );
};
